import type { ModalIdentifier, ModalPayload, SilverfinEvents } from '@app/types'

export default class BaseModalHandler {
  _addAppModalClass(): void {
    window.requestAnimationFrame(() => {
      document.body.classList.add('sf-body__modal-open')
    })
  }

  _removeAppModalClass(): void {
    window.requestAnimationFrame(() => {
      document.body.classList.remove('sf-body__modal-open')
    })
  }

  _emitModalOpened<T extends ModalIdentifier>(
    modalIdentifier: T,
    params?: ModalPayload<T>
  ): void {
    window.eventHub.$emit('modal-opened')

    const emitEvent = <K extends ModalIdentifier>(
      identifier: K,
      payload: ModalPayload<K> | undefined
    ): void => {
      if (payload !== undefined) {
        window.eventHub.$emit(
          `${identifier}-opened`,
          payload as SilverfinEvents[`${K}-opened`]
        )
      } else {
        window.eventHub.$emit(
          `${identifier}-opened`,
          undefined as SilverfinEvents[`${K}-opened`]
        )
      }
    }

    emitEvent(modalIdentifier, params)
  }

  _emitModalClosed<T extends ModalIdentifier>(modalIdentifier: T): void {
    window.eventHub.$emit(`${modalIdentifier}-closed`, undefined)
  }
}
